
import { Box, Stack, Card, CardContent } from "@mui/material";
import './index.scss';
import { colorTheme } from "../../../constants";
import { SxProps, Theme } from "@mui/material/styles";


type sort = {
    key: string,
    direction?: 'asc' | 'desc'
}

type columnVisibilityModel = {
    [column: string]: boolean
}

const CardTable = ({
    rows, 
    columns, 
    sort, 
    onClick,
    columnVisibilityModel,
    getCellClassName,
    sx,
} : {
    rows: any[], 
    columns: any[], 
    sort?: sort, 
    onClick?: (params:any) => any,
    columnVisibilityModel?: columnVisibilityModel ,
    getCellClassName?:(params:any) => string,
    sx?: SxProps<Theme>;
}) => {
    

    if (!rows || !columns) {
        return (<></>)
    } else {
        if (sort) {
            rows = [...rows].sort((a, b) => (
                sort.direction === 'desc' ? (b[sort.key] - a[sort.key]) : (a[sort.key] - b[sort.key])
            ))
        }
        return (
            <Box sx={sx}>
                <Stack spacing={2} sx={{ mt: 2, pb:1}}>
                    {
                        rows.map((row) => (
                            <Card 
                                key={row.id} 
                                sx={{ 
                                borderRadius: 3, 
                                boxShadow: 3, 
                                p: 0, 
                                backgroundColor: '#fff' 
                                }}
                                onClick={onClick ? () => onClick(row) : () => {return -1}}
                            >
                                <CardContent
                                    sx={{
                                        p:2,
                                        backgroundColor:colorTheme.light.background_grey,
                                        "&:hover" : {
                                            backgroundColor: colorTheme.light.background_dark_grey,
                                            cursor: 'pointer'
                                        }
                                    }}
                                >
                                    { 
                                        columns.map((col) => {
                                            if (columnVisibilityModel) {
                                                if (col.field in columnVisibilityModel) {
                                                    return
                                                }
                                            }
                                            return(
                                                <div>
                                                    <div className="column-header">{`${col.headerName}`}</div>
                                                    {col.renderCell ? (
                                                        <div className={`row-data ${getCellClassName ? getCellClassName({ row, field: col.field, value: row[col.field] }) : ""}`}>
                                                            {col.renderCell({ row, value: row[col.field] })}
                                                        </div>
                                                        
                                                    ) : (
                                                        <div className={`row-data ${getCellClassName ? getCellClassName({ row, field: col.field, value: row[col.field] }) : ""}`}>{`${row[col.field]}`}</div>
                                                    )}
                                                </div>
                                            )
                                        })
                                    }
                                </CardContent>
                            </Card>
                        ))
                    }
                </Stack>
            </Box>
        )
    }
   
};

export default CardTable;